module.exports = __webpack_public_path__ + "img/boy_black_stache.8a3c30af.png";